import './index.less';

const { ont } = window.utils;

const renderDepositRow = (data) => {
  return `
    <tr>
        <td class="column column0-wrapper">${data.currency}</td>
        <td class="column">${data.network}</td>
        <td class="column">${data.deposit_fee}</td>
        <td class="column">${data.deposit_min_size}</td>
        <td class="column">${data.deposit_confirmations}</td>
    </tr>
  `;
};

const renderWithdrawRow = (data) => {
  return `
    <tr>
        <td class="column column0-wrapper">${data.currency}</td>
        <td class="column">${data.network}</td>
        <td class="column">${data.withdraw_fee_min}~${data.withdraw_fee_max}</td>
        <td class="column">${data.withdraw_min_size}</td>
        <td class="column">${data.withdraw_max_size}</td>
    </tr>
  `;
};

window.addEventListener('DOMContentLoaded', () => {
  ont.get('/v2/asset/introduction/depositRules').then((rulesRes) => {
    const { data } = rulesRes.data;
    const depositFeesContent = data
      .map((item) => {
        return renderDepositRow(item);
      })
      .join('');
    document.getElementById('depositFeesBody').innerHTML = depositFeesContent;
  });
  ont.get('/v2/asset/introduction/withdrawRules').then((rulesRes) => {
    const { data } = rulesRes.data;
    const withdrawFeesContent = data
      .map((item) => {
        return renderWithdrawRow(item);
      })
      .join('');
    document.getElementById('withdrawFeesBody').innerHTML = withdrawFeesContent;
  });
});
